
let timelineElements = [
  {
    id: 1,
    title: "Primo regolo calcolatore",
    location: "",
    description:
      "Il regolo calcolatore è una specie di righello graduato che sfrutta le proprietà dei logaritmi, riconducendo operazioni più complesse (prodotti, quozienti, esponenziali) ad operazioni più semplici sui logaritmi dei rispettivi operandi. Queste vengono eseguite graficamente, spostando una o più asticelle graduate con scala logaritmica.",
    buttonText: "",
    date: "1622",
    icon: "",
    page: "",
    image: "regolo.jpg"
  },
  {
    id: 2,
    title: "La Pascalina",
    location: "",
    description:
      "Blaise Pascal inventò la prima calcolatrice meccanica in grado di eseguire addizioni e sottrazioni.",
    buttonText: "",
    date: "1642",
    icon: "",
    page: "",
    image: "pascalina.jpg"
  },
  {
    id: 3,
    title: "Ruota di Leibniz",
    location: "",
    description:
      "Gottfried Leibniz costruì un dispositivo (la Ruota di Leibniz) che era in grado di eseguire addizioni, sottrazioni, ma anche moltiplicazioni e divisioni.",
    buttonText: "",
    date: "1673",
    icon: "",
    page: "",
    image: "ruota-di-leibniz.jpeg"
  },
  {
    id: 4,
    title: "Telaio di Jacquard",
    location: "",
    description:
      "Joseph Jacquard, costruì il primo dispositivo programmabile ma che non eseguiva nessun calcolo; si trattava infatti di un telaio che, mediante delle schede perforate, a seconda della scheda si poteva ottenere una specifica tessitura.",
    buttonText: "",
    date: "1801",
    icon: "",
    page: "",
    image: "telaio-jacquard.jpg"
  },
  {
    id: 5,
    title: "Charles Babbage",
    location: "",
    description:
      "Nel 1823, ispirato dal lavoro di Jacquard, il matematico inglese Charles Babbage (1791-1871) costruì una macchina e le diede il nome di 'Difference Engine'; questa macchina riusciva a risolvere equazioni complesse ed era anche programmabile. Lo stesso Babbage, inoltre, ideò delle macchine ancora più potenti ma non riuscì a costruirle perchè le sue idee andavano ben oltre alla fattibilità costruttiva dell'epoca. La sua 'Analytical Engine', poteva risolvere problemi numerici più complessi e con una maggior precisione; la sua architettura conteneva le quattro parti principali degli attuali calcolatori, cioè l'Unità logico/aritmetica (ALU), Memoria, Processore, Unità di input/output.",
    buttonText: "..more..",
    date: "1823",
    icon: "",
    page: "babbage.html",
    image: "analytical-engine.jpg"
  },
  {
    id: 6,
    title: "Primi del 900",
    location: "",
    description:
      "Herman Hollerith, che divenne poi il fondatore della IBM (nel 1924), era uno statistico dell'ufficio censimenti degli Stati Uniti. Per conteggiare i risultati del censimento del 1890, costruì una macchina programmabile che usava delle schede perforate. L'idea era che potesse essere usata anche per inventari di magazzino, dati di vendita o buste paga.",
    buttonText: "",
    date: "Primi del 1900",
    icon: "",
    page: "",
    image: "hollerith-machine.jpg"
  },
  {
    id: 7,
    title: "Mark I",
    location: "",
    description:
      "Durante la seconda guerra mondiale, questi calcolatori ebbero nuovi scopi: calcolare traiettorie balistiche e decifrare codici segreti. La marina degli Stati Uniti ed IBM a partire dal 1937, inziarono lo sviluppo del primo calcolatore 'general purpose', cioè che poteva essere usato per scopi non specifici, chiamato Mark I finito di costruire nel 1943; fu il primo elaboratore ad utilizzare il sistema di numerazione binario. Nel 1943, sotto la direzione di Alan Touring venne costruito 'Colossus', utilizzato per violare il famoso codice segreto nazista denominato 'Enigma'.",
    buttonText: "",
    date: "Seconda Guerra Mondiale",
    icon: "",
    page: "",
    image: "mark-I.jpg"
  },
  {
    id: 8,
    title: "ENIAC",
    location: "",
    description:
      "Nel 1946, sempre per scopi militari, fu finito di costruire il primo calcolatore interamente elettronico: il suo nome era 'ENIAC (Electronic Numerical Integrator and Calculator)' ed aveva una velocità di computazione 1000 volte superiore a quella di Mark I. Si possono citare ulteriori sistemi di calcolatori, come 'ABC' (Atanasoff-Berry Computer, 1939-1942), capace però di risolvere un unico problema, i sistemi di equazioni lineari.",
    buttonText: "",
    date: "1946",
    icon: "",
    page: "",
    image: "eniac.png"
  },
  {
    id: 9,
    title: "Von Neumann",
    location: "",
    description:
      "Una delle persone più geniali mai esistite fu John Von Neumann (1903-1957), che nel 1946 diede un contributo fondamentale all'architettura degli elaboratori, progettando il primo 'calcolatore a programma memorizzato' (stored program computer, 1946). Sulla base delle sue idee si costruirono intorno agli anni '50, calcolatori come EDSAC ed EDVAC. Nel 1951 il modello commerciale di EDVAC, chiamato UNIVAC-I, fu venduto al Census Bureau of USA rimanendo operativo per 12 anni. Fino a prima dell'avvento di Von Neumann, i calcolatori dovevano essere programmati esternamente, ossia connettendo migliaia di cavi elettrici in una certa maniera e a secondo del programma da eseguire, mentre la memoria del calcolatore, era pensata solamente per i dati da elaborare. Con Von Neumann, si introdusse la codifica binaria delle istruzioni per la programmabilità, nel senso che il calcolatore poteva essere programmato internamente agendo sulla memoria che poteva archiviare tali istruzioni. Molte furono le intuizioni avute da Von Neumann, infatti ancora oggi in suo onore si parla di modelli di calcolatori sviluppati secondo l'Architettura di Von Neumann.",
    buttonText: "",
    date: "1951",
    icon: "",
    page: "",
    image: "edsac.gif"
  },
  {
    id: 10,
    title: "Prima generazione",
    location: "",
    description:
      "UNIVAC I è il primo computer costruito per essere venduto. Venivano usati tubi a vuoto per l'elaborazione e l'archiviazione dei dati. Date le enormi dimensioni, venivano posti in luoghi dedicati (agenzie governative, istituti militari, grosse aziende, laboratori di ricerca o universitari...) ed era utilizzato solamente da personale specializzato.",
    buttonText: "",
    date: "1950-1957",
    icon: "",
    page: "",
    image: "univac-I.jpg"
  },
  {
    id: 11,
    title: "Seconda generazione",
    location: "",
    description:
      "I transistor sostituiscono i tubi a vuoto. Avevano la dimensione di pochi millimetri e la memoria veniva costruita usando piccoli nuclei magnetici. Si riducono così le dimensioni dei calcolatori, dimuiscono i costi e aumenta l'affidabilità. Nascono i primi linguaggi di programmazione ad alto livello (Fortran e Cobol).",
    buttonText: "",
    date: "1957-1965",
    icon: "",
    page: "",
    image: "tx-o.jpg"
  },
  {
    id: 12,
    title: "Terza generazione",
    location: "",
    description:
      "Si usano i circuiti integrati (con transistor, resistori, condensatori). Ad esempio, le superfici di silicio vengono incise con tecniche fotografiche. PDP-1 è stato il primo minicomputer prodotto da DEC (Digital Equipment Corp). Aumentano gli utenti e nacque così l'industria del software (primi pacchetti sofware di gestione amministrativa e programmi di elaborazione statistica).",
    buttonText: "",
    date: "1965-1975",
    icon: "",
    page: "",
    image: "dec-pdp-1.jpeg"
  },
  {
    id: 13,
    title: "Quarta generazione",
    location: "",
    description:
      "L'intero sistema di elaborazione poteva essere contenuto in una singola scheda circuitale. Le macchine avevano una dimensione tale da poter stare su una scrivania. Il primo microcomputer è del 1975, chiamato Altair 8800. Per quanto riguarda il software, naquero i primi fogli di calcolo, basi di dati, elaboratori di testo e presentazioni grafiche. In questo periodo vennero realizzate anche sia le prime reti di calcolatori, interfacce grafiche per gli utenti (user friendly), sia dei sistemi incorportati (embedded) negli elettrodomestici.",
    buttonText: "",
    date: "1975-1985",
    icon: "",
    page: "",
    image: "altair-8800.jpg"
  },
  {
    id: 14,
    title: "Quinta generazione",
    location: "",
    description:
      "Fino ad ora, il modello teorico che descrive il progetto e la costruzione dei computer non ha subito modifiche rilevanti, infatti vale ancora l'architettura di Von Neumann. Nuovi approcci potrebbero essere utilizzati nei secoli futuri (vedi computazione quantistica).",
    buttonText: "",
    date: "1985-ad oggi",
    icon: "",
    page: "",
    image: "computer-oggi.png"
  }
];

export default timelineElements;
